module.exports = __webpack_public_path__ + "static/media/bareng.4dde6f19.jpeg";